import { defineRouting } from 'next-intl/routing';
import { CookiesType } from 'types/enums';

export const routing = defineRouting({
  locales: ['ru', 'en', 'ua'],

  defaultLocale: 'ru',
  localeDetection: true,
  localePrefix: 'never',
  localeCookie: {
    name: CookiesType.locale,
    path: '/',
    sameSite: 'lax',
    secure: false,
    maxAge: 60 * 60 * 24 * 30,
  },
});

export type SupportedLocales = (typeof routing.locales)[number];
